module.exports = __webpack_public_path__ + "img/logotaliya.e2c932d5.svg";